import { render, staticRenderFns } from "./CatalogProductItem.vue?vue&type=template&id=5e004052&scoped=true&"
import script from "./CatalogProductItem.vue?vue&type=script&lang=js&"
export * from "./CatalogProductItem.vue?vue&type=script&lang=js&"
import style0 from "./CatalogProductItem.vue?vue&type=style&index=0&id=5e004052&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e004052",
  null
  
)

export default component.exports